import { Link } from "react-router-dom";
import "./AboutContentStyle.css";
import img1 from "../assets/img1.jpg";
import img2 from "../assets/img2.jpg";
import React from 'react'

const AboutContent = () => {
  return (
    <div className="about">
        <div className="left">
            <h1>Who Am I?</h1>
            <p>Je suis diplômé en ingénierie des systèmes d’information en informatique.
Développeur web avec ReactJS et PHP Laravel, mobile avec Flutter et desktop avec Python et Java.
Je conçois des solutions modernes, performantes et adaptées aux besoins des utilisateurs.
</p>
            <Link to="/contact">
            <button className="btn">contact</button>
        </Link>
        </div>
        
        <div className="right">
            <div className="img-container">
                <div className="img-stack top">
                <img src={img1} alt="image" className="img" />
                </div>
            
            
                <div className="img-stack bottom">
                <img src={img2} alt="image" className="img" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutContent